import { IconProps } from "./Icons";

export const IconInfoMessage = ({
  width = 22,
  height = 22,
  color = "white",
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.35365 19.9803C1.00823 20.0464 0.70425 19.7448 0.767803 19.3989L1.60714 14.8305C1.03571 13.5661 0.749997 12.1868 0.749997 10.75C0.749997 5.23276 5.20714 0.75 10.6929 0.75C16.1786 0.75 20.6357 5.23276 20.6357 10.75C20.6357 16.2672 16.1786 20.75 10.6929 20.75C8.75 20.75 6.92143 20.1753 5.43571 19.1983L1.35365 19.9803Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.94997 7.93371C9.7214 7.70383 9.60712 7.41647 9.60712 7.07164C9.60712 6.72682 9.7214 6.43946 9.94997 6.20957C10.1785 5.97969 10.4643 5.86475 10.8071 5.86475C11.15 5.86475 11.4357 5.97969 11.6643 6.20957C11.8928 6.43946 12.0071 6.72682 12.0071 7.07164C12.0071 7.41647 11.8928 7.70383 11.6643 7.93371C11.4357 8.1636 11.15 8.27854 10.8071 8.27854C10.4643 8.27854 10.1785 8.1636 9.94997 7.93371ZM11.6643 15.6349H9.89283C9.83569 15.6349 9.77855 15.5774 9.77855 15.5199V10.1176C9.77855 10.0601 9.83569 10.0027 9.89283 10.0027H11.6643C11.7214 10.0027 11.7785 10.0601 11.7785 10.1176V15.5199C11.8357 15.5774 11.7785 15.6349 11.6643 15.6349Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
